import React from 'react';
import ChartComponent from './ChartComponent';

const OrderStatusChart = ({ data }) => {
    const aggregation = { 'PENDING': 0, 'AWAITING USER ACTION': 0, "AWAITING VENDOR ACTION": 0, CLOSED: 0 };

    data.forEach((order) => {
        if (order.status in aggregation) {
            aggregation[order.status] += 1;
        }
    });

    const chartData = {
        labels: ['Pending', 'In Progress', 'Canceled', 'Closed'],
        datasets: [
            {
                label: 'Order Status Distribution',
                data: [aggregation['PENDING'], aggregation['AWAITING USER ACTION'], aggregation["AWAITING VENDOR ACTION"], aggregation.CLOSED],
                backgroundColor: [
                    'rgba(255, 159, 64, 0.6)',  // Orange for pending
                    'rgba(75, 192, 192, 0.6)',  // Teal for in progress
                    'rgba(255, 99, 132, 0.6)',  // Red for canceled
                    'rgba(153, 102, 255, 0.6)',  // Purple for closed
                ],
                borderColor: [
                    'rgba(255, 159, 64, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(255, 99, 132, 1)',
                    'rgba(153, 102, 255, 1)',
                ],
                borderWidth: 1,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top', // Position of the legend
                labels: {
                    generateLabels: (chart) => {
                        const datasets = chart.data.datasets;
                        return datasets[0].data.map((data, index) => {
                            return {
                                text: `${chart.data.labels[index]}`,
                                fillStyle: datasets[0].backgroundColor[index],
                                strokeStyle: datasets[0].borderColor[index],
                                lineWidth: datasets[0].borderWidth,
                                hidden: chart.getDatasetMeta(0).data[index].hidden,
                                index: index,
                            };
                        });
                    },
                },
            },
            title: {
                display: true,
                text: 'Order Status Distribution', // Chart title
                font: {
                    size: 18,
                    weight: 'bold',
                },
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem) => {
                        const label = tooltipItem.label;
                        const value = tooltipItem.raw;
                        const icon = getIconForStatus(label);
                        return `${label})`;
                    },
                },
            },
        },
    };

    // Helper function to get Bootstrap icon for each order status
    const getIconForStatus = (status) => {
        switch (status) {
            case 'Pending':
                return 'bi-hourglass-split'; // Pending icon
            case 'In Progress':
                return 'bi-gear-fill'; // In progress icon
            case 'Canceled':
                return 'bi-x-circle-fill'; // Canceled icon
            default:
                return '';
        }
    };

    return (
        <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center' }}>
            <ChartComponent type="pie" data={chartData} options={chartOptions} />
        </div>
    );
};

export default OrderStatusChart;
